import '@fortawesome/fontawesome-free/css/all.min.css';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import './index.css';
import { appRouting } from './routing/routes.tsx';

Sentry.init({
  dsn: 'https://b419aa211d2bc506fa9f185a2514d796@o4509067241455616.ingest.de.sentry.io/4509067243618384',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/.*kotobekia\.com\/api/],
  enabled: process.env.NODE_ENV !== 'development',
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        // Don't retry on auth, forbidden, or not-found errors
        const status = error?.response?.status || error?.status;
        if (status === 401 || status === 403 || status === 404) {
          return false;
        }
        // Retry up to 2 times for other errors
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});
createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={appRouting} />
    {/* <ReactQueryDevtools initialIsOpen={false} client={queryClient} /> */}
  </QueryClientProvider>
);
